import React from 'react';
import DisModal from './design-system/DisModal';
import DisButton from './design-system/DisButton';

const BadgeUnlockModal = ({ badge, onClose }) => {
  if (!badge) return null;

  return (
    <DisModal isOpen={true} onClose={onClose} title="">
      <div className="text-center space-y-4 py-4" data-testid="badge-unlock-modal">
        <div className="text-6xl animate-bounce">
          {badge.icon === 'star' && '\u2B50'}
          {badge.icon === 'microscope' && '\uD83D\uDD2C'}
          {badge.icon === 'book_open' && '\uD83D\uDCDA'}
          {badge.icon === 'brain' && '\uD83E\uDDE0'}
          {badge.icon === 'book' && '\uD83D\uDCD6'}
          {badge.icon === 'flame' && '\uD83D\uDD25'}
          {badge.icon === 'trophy' && '\uD83C\uDFC6'}
        </div>
        <h2 className="text-xl font-bold text-gray-800" style={{ fontFamily: "'Caveat', cursive" }}>
          {badge.child_name} vient de gagner un badge !
        </h2>
        <div className="bg-amber-50 rounded-2xl p-4 inline-block">
          <p className="text-lg font-bold text-amber-700">{badge.name}</p>
          <p className="text-sm text-amber-500">{badge.description}</p>
        </div>
        <DisButton
          onClick={onClose}
          className="bg-gradient-to-r from-amber-400 to-amber-500 text-white font-medium"
          data-testid="badge-close-btn"
        >
          Super !
        </DisButton>
      </div>
    </DisModal>
  );
};

export default BadgeUnlockModal;
